import React, {useState} from "react"
import styled from "styled-components"
import {DatePicker, Input, Select} from "@irati/ui/src/FormItem"
import Spacing from "@irati/ui/src/Spacing"
import {Body, H3, H4} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {basket} from "./dummyData"
import Item from "../components/Item"

const CheckoutScreen = () => {
  const [activeStep, setActiveStep] = useState<"details" | "delivery">("details")
  const handleButtonClick = () => {
    if (activeStep === "details") {
      setActiveStep("delivery")
    } else {
      console.log("go to success")
    }
  }

  return (
    <OuterContainer>
      <FormContainer>
        <Steps>
          <StepItem onClick={() => setActiveStep("details")}>
            <ItemNumber isActive={activeStep === "details"}>1</ItemNumber>
            <ItemLabel>Your details</ItemLabel>
          </StepItem>
          <StepItem onClick={() => setActiveStep("delivery")}>
            <ItemNumber isActive={activeStep === "delivery"}>2</ItemNumber>
            <ItemLabel>Submit order</ItemLabel>
          </StepItem>
        </Steps>

        {activeStep === "details" ? (
          <>
            <Input label="Place of work" name="placeOfWork" value="The Office" />
            <Input label="Employee number" name="employeeNumber" value="BACKEND_EMPLOYEE_NUMBER" />
            <Input label="National Insurance Number" name="niNumber" value="AB123456A" />
            <Input label="First Name" name="firstName" value="Vivup" />
            <Input label="Last Name" name="lastName" value="Team" />
            <Spacing margin={[2, 0]}>
              <Select
                label="Title"
                name="title"
                options={[
                  {label: "Mr", value: "mr"},
                  {label: "Ms", value: "ms"}
                ]}
                onChange={() => {}}
                formatMessage={{id: ""}}
              />
            </Spacing>

            <Input label="Email address" name="email" value="hello@vivup.co.uk" />
            <Input label="Mobile number" name="mobileNumber" value="07987654321" />
            <Input label="Phone number" name="phoneNumber" value="07987654321" />

            <DatePicker label="Date of Birth" icon />
          </>
        ) : (
          <>
            <Spacing padding={[1, 2]}>
              <Body>This is the address your employer has on record for you</Body>
            </Spacing>
            <Input label="Line 1" name="lineOne" value="Surrey Technology Centre" />
            <Input label="Line 2" name="lineTwo" value="Occam Road, Surrey Research Park" />
            <Input label="Town" name="town" value="Guildford" />
            <Input label="County" name="county" value="Surrey" />
            <Input label="Post Code" name="postCode" value="GU2 7YG" />
          </>
        )}
        <Spacing marginTop={2} padding={[0, 2]}>
          {activeStep === "details" ? (
            <Button full primary marginTop="33px" onClick={handleButtonClick}>
              Continue to delivery
            </Button>
          ) : (
            <ButtonRouterLink full primary marginTop="33px" to="/thank-you">
              Submit order
            </ButtonRouterLink>
          )}
        </Spacing>
      </FormContainer>

      <Spacing hideOnMobile style={{width: "51%"}}>
        <OrderSummary>
          <SummaryContent>
            <SummaryTitle>Order summary</SummaryTitle>
            {basket.basketItems.map(({imageUrl, name, price}, index) => {
              return <Item imageUrl={imageUrl} name={name} price={price} key={index} />
            })}

            <Spacing padding={[2.5, 0]}>
              <H4>{basket.term} month term</H4>
              <Body margin={[1, 0]}>Total monthly amount from take home pay ({basket.count} items):</Body>

              <Body margin={[1.5, 0]}>
                <Price>£{basket.monthlyPrice}</Price>
                &nbsp; per month
              </Body>

              <Body>Total gross monthly reduction:</Body>
              <Body>£{basket.totalMonthlyGrossAmount} as seen on payslip</Body>
            </Spacing>
          </SummaryContent>
        </OrderSummary>
      </Spacing>
    </OuterContainer>
  )
}

export default CheckoutScreen

const OuterContainer = styled.div`
  padding: 0 12px;
  max-width: 1380px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
`

const FormContainer = styled.div`
  width: 100%;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 42.5%;
    padding: 0 14px;
    margin-right: 16px;
  `}
`

const Steps = styled.div`
  display: flex;
  padding: 28px 0 26px 28px;
`

const StepItem = styled.div`
  display: flex;
  margin-right: 24px;
  cursor: pointer;
  border-radius: 4px;
  padding: 2px;
`

interface ItemNumberProps {
  isActive: boolean
}

const ItemNumber = styled.div<ItemNumberProps>`
  width: 20px;
  height: 20px;
  color: ${({theme, isActive}) => (isActive ? theme.colors.greys.white : theme.colors.primary1)};
  background-color: ${({theme, isActive}) => (isActive ? theme.colors.primary1 : theme.colors.greys.white)};
  border-radius: 50%;
  border: 1px solid ${({theme}) => theme.colors.primary1};
  font-size: 12px;
  font-weight: ${({theme, isActive}) => (isActive ? 700 : 500)};
  margin-right: 4px;
  text-align: center;
`

const ItemLabel = styled(H4)`
  font-weight: 500;
  align-self: center;
` as typeof H4

const OrderSummary = styled.div`
  $box-shadow: 0rem 0.1875rem 0.375rem #00000029;
  border: 0.0625rem solid ${({theme}) => theme.colors.greys.light};
  border-radius: 16px;
  position: sticky;
  top: 160px;
`

const SummaryContent = styled.div`
  padding: 36px 44px 0 28px;
  color: ${({theme}) => theme.colors.primary1};
  max-height: 60vh;
  overflow: auto;
  position: relative;
`

const SummaryTitle = styled(H3)`
  color: ${({theme}) => theme.colors.primary1_600};
`

const Price = styled(Body)`
  display: inline;
  font-size: 24px;
  font-weight: 700;
  color: ${({theme}) => theme.colors.primary1};
`
